import React from "react";

// components
import BottomBanner from "elements/BottomBanner";
import LandingBanner from "elements/LandingBanner";
// import PopularGameSlider from "elements/games_elements/PopularGameSlider";
import FeturedItem from "elements/FeturedItem";
import PromotionSlider from "elements/PromotionSlider";
// import GameSlider from "elements/games_elements/GameSlider";
import SportsBetting from "elements/SportsBetting";
import Faqs from "../elements/Faqs";
import UpcomingTournaments from "elements/games_elements/UpcomingTournaments";

export default function SportsLanding(props) {
  return (
    <div className="joker_landing_page">
      <LandingBanner {...props} />
      <SportsBetting {...props} />
      <PromotionSlider {...props} />
      <FeturedItem {...props} />
      <UpcomingTournaments {...props} />
      <BottomBanner {...props} />
      <Faqs {...props} />
    </div>
  );
}
